import { Select, Tooltip } from "antd";
import React from "react";
import { useNotification } from "../../../contexts/Notifications";
import { useGetAllSpaceTagsQuery } from "../../../generated/types";
import { Project } from "../../../types";
import styles from "../selectorStyles.module.css";
import { TAGS_LOADING_ERROR } from "./messages";

export type Props = {
  selectedTags: string[];
  project: Project;
  disabled?: boolean;
  placeholder?: string;
  onChange: (value: string[]) => void;
  allowCreatingNewValue?: boolean;
};

export const SpaceTagsSelector = (props: Props) => {
  const {
    data: allTypeTags,
    error,
    loading,
  } = useGetAllSpaceTagsQuery({
    variables: {
      customer: props.project.customer,
      project: props.project.project,
      scope: props.project.scope,
    },
  });
  const notify = useNotification();

  if (error) {
    notify(TAGS_LOADING_ERROR, "error");
  }

  return (
    <Select
      allowClear
      disabled={props.disabled || !!error}
      loading={loading}
      className={styles.selector}
      value={props.selectedTags}
      mode={props.allowCreatingNewValue ? "tags" : "multiple"}
      placeholder={props.placeholder ?? "Select..."}
      onChange={props.onChange}
    >
      {allTypeTags?.spaceTags.map((tag) => (
        <Select.Option key={tag} value={tag}>
          <Tooltip title={tag}>{tag}</Tooltip>
        </Select.Option>
      ))}
    </Select>
  );
};
